import { AmountWithIcon } from "@/components/AmountWithIcon"
import { Icon } from "@/components/Icon"
import { CryptoMerchantInfo } from "@/stores/CryptoMerchatStore"
import { amountFormat } from "@/utils/tool"


export const level: Record<string, {
  value: string,
  text: string
}> = {
  SILVER:{value: 'silver',text: '白银'},
  ORDINARY:{value: 'normal',text: '黄金'},
  Platinum:{value: 'platinum',text: '铂金'},
  Diamond:{value: 'diamond',text: '钻石'},
  CROWN:{value: 'crown',text: '皇冠'},
  DEFAULT:{value: 'default',text: '普通'},
}


export const actionBtns = [
  {
      action: 'navigateToTransfer', btn: '划转', title: '保证金',
      amout: (cryptoMerchantInfo: CryptoMerchantInfo) => `${amountFormat(cryptoMerchantInfo.businessAssureBalance, {places: 2})}U`,
      icon: <Icon name={'margin_balance'} size={'0.2rem'}/>
  },
  {
      action: 'interestSettlement', btn: '领取', title: '利息',
      amout: (cryptoMerchantInfo: CryptoMerchantInfo) => `${amountFormat(cryptoMerchantInfo.interestSettlement, {places: 2})}U`,
      icon: <Icon name={'profit'} size={'0.2rem'}/>
  },
  {
      action: 'refresh',btn: '刷新', title: '商家余额',
      amout: (cryptoMerchantInfo: CryptoMerchantInfo) => 
        <AmountWithIcon amount={amountFormat(cryptoMerchantInfo.businessBalance, {places: 2})} size={'0.24rem'} />,
      icon: <Icon name={'seller_balance'} size={'0.2rem'}/>
  },
]


export const transferBtns = [
  {action: 'transferin', title: '转入',},
  {action: 'transferout', title: '转出',},
  {action: 'transfertoearn', title: '开始赚钱',},
]